import React from 'react';
import { Typography } from 'tfc-components';

import Icon, { IconName } from 'components/atoms/Icon';

interface IssueCardProps {
  icon: IconName;
  title: string;
  description: string;
}

const IssueCard: React.FC<IssueCardProps> = ({ icon, title, description }) => (
  <div className="m-issueCard">
    <div className="m-issueCard_icon">
      <Icon iconName={icon} size="44" />
    </div>
    <Typography.Text extendClasses="m-issueCard_title f-20x24" fontweight="600">
      {title}
    </Typography.Text>
    <Typography.Text extendClasses="m-issueCard_description f-20x24" fontweight="400">
      {description}
    </Typography.Text>
  </div>
);

export default IssueCard;
